const _temp0 = require("./common/unsorted.path.js");

const _temp1 = require("./common/powerups/powerups.path.js");



const _temp2 = require("./intro/intro.path.js");


const _temp3 = require("./enemies/BulletDrone/bulletDrone.path.js");


const _temp4 = require("./enemies/Drone/drone.path.js");


const _temp5 = require("./enemies/Helicopter/helicopter.path.js");


const _temp6 = require("./enemies/LargeDrone/largeDrone.path.js");



const _temp7 = require("./sinterklaas/Bird/bird.path.js");


const _temp8 = require("./sinterklaas/Fish/fish.path.js");


const _temp9 = require("./sinterklaas/House/House.path.js");


const _temp10 = require("./sinterklaas/Seagull/seagull.path.js");



module.exports = {
  "common":   {
    "unsorted":     {
      "js": _temp0
    },
    "powerups":     {
      "powerups":       {
        "js": _temp1
      }
    }
  },
  "intro":   {
    "intro":     {
      "js": _temp2
    }
  },
  "enemies":   {
    "BulletDrone":     {
      "bulletDrone":       {
        "js": _temp3
      }
    },
    "Drone":     {
      "drone":       {
        "js": _temp4
      }
    },
    "Helicopter":     {
      "helicopter":       {
        "js": _temp5
      }
    },
    "LargeDrone":     {
      "largeDrone":       {
        "js": _temp6
      }
    }
  },
  "sinterklaas":   {
    "Bird":     {
      "bird":       {
        "js": _temp7
      }
    },
    "Fish":     {
      "fish":       {
        "js": _temp8
      }
    },
    "House":     {
      "House":       {
        "js": _temp9
      }
    },
    "Seagull":     {
      "seagull":       {
        "js": _temp10
      }
    }
  }
}